"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@veeam/core");
var WizardInteractor = /** @class */ (function (_super) {
    __extends(WizardInteractor, _super);
    function WizardInteractor(router, listener, presenter, config) {
        if (config === void 0) { config = { isNextStepAvailable: true }; }
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.listener = listener;
        _this.presenter = presenter;
        _this.config = config;
        _this.loading = 0;
        _this.pending = 0;
        _this.stepRegistry = {};
        _this.completedIndex = {};
        _this.stepsUnavailability = {};
        _this.stepsDisableState = {};
        _this.currentStepId = '';
        _this.presenter.listener = _this;
        return _this;
    }
    WizardInteractor.prototype.willActivate = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, ((_a = this.router) === null || _a === void 0 ? void 0 : _a.attachSteps())];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.switchStepById(this.getStartStepId())];
                    case 2:
                        _b.sent();
                        this.currentStepId = this.getStartStepId();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.internalDidCatchError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.tryCompleteAllSteps = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var ids, completedIds, result, _i, ids_1, id, ok;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.startLoading();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 7, 8]);
                        ids = this.getNotDisabledAvailableStepIDs();
                        completedIds = [];
                        result = { ok: true, completedIds: completedIds };
                        _i = 0, ids_1 = ids;
                        _b.label = 2;
                    case 2:
                        if (!(_i < ids_1.length)) return [3 /*break*/, 5];
                        id = ids_1[_i];
                        return [4 /*yield*/, ((_a = this.router) === null || _a === void 0 ? void 0 : _a.completeStepById(id))];
                    case 3:
                        ok = _b.sent();
                        if (!ok) {
                            result = {
                                completedIds: completedIds,
                                ok: false,
                                firstFailedStepId: id
                            };
                            return [3 /*break*/, 5];
                        }
                        this.completedIndex[id] = ok;
                        completedIds.push(id);
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [4 /*yield*/, this.updateNavigation()];
                    case 6:
                        _b.sent();
                        return [2 /*return*/, result];
                    case 7:
                        this.cancelLoading();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.didSelectStepById = function (nextStepId) {
        return __awaiter(this, void 0, void 0, function () {
            var stepIDs, currentIndex, nextIndex, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        stepIDs = this.getAvailableStepIDs();
                        currentIndex = stepIDs.indexOf(this.currentStepId);
                        nextIndex = stepIDs.indexOf(nextStepId);
                        if (nextIndex < 0) {
                            throw new Error('WizardInteractor error: can not switch route, route not available or not exist');
                        }
                        if (nextIndex === currentIndex) {
                            return [2 /*return*/];
                        }
                        if (!(nextIndex > currentIndex)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.completeCurrentStep()];
                    case 1:
                        if (!(_a.sent())) {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.switchStepById(nextStepId)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        this.internalDidCatchError(e_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.didSelectNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ok, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.completeCurrentStep()];
                    case 1:
                        ok = _a.sent();
                        if (!ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.switchStepById(this.getNextOrPrevStepId(1))];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        this.internalDidCatchError(e_3);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.didSelectPrev = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.switchStepById(this.getNextOrPrevStepId(-1))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _a.sent();
                        this.internalDidCatchError(e_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.didSelectSkip = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.switchStepById(this.getNextOrPrevStepId(1))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        this.internalDidCatchError(e_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.didSelectDone = function () {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var ok, e_6, ok, err_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.completeCurrentStep()];
                    case 1:
                        ok = _f.sent();
                        if (!ok) {
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_6 = _f.sent();
                        this.internalDidCatchError(e_6);
                        return [3 /*break*/, 3];
                    case 3:
                        _f.trys.push([3, 5, , 6]);
                        this.startLoading();
                        return [4 /*yield*/, ((_b = (_a = this.listener).willDone) === null || _b === void 0 ? void 0 : _b.call(_a))];
                    case 4:
                        ok = (_c = (_f.sent())) !== null && _c !== void 0 ? _c : true;
                        if (ok) {
                            (_e = (_d = this.listener).didDone) === null || _e === void 0 ? void 0 : _e.call(_d);
                            return [2 /*return*/];
                        }
                        this.cancelLoading();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _f.sent();
                        this.internalDidCatchError(err_1);
                        this.cancelLoading();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.didSelectCancel = function () {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, 3, 4]);
                        this.startLoading();
                        return [4 /*yield*/, ((_b = (_a = this.listener).willCancel) === null || _b === void 0 ? void 0 : _b.call(_a))];
                    case 1:
                        if ((_c = (_f.sent())) !== null && _c !== void 0 ? _c : true) {
                            (_e = (_d = this.listener).didCancel) === null || _e === void 0 ? void 0 : _e.call(_d);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _f.sent();
                        this.internalDidCatchError(err_2);
                        return [3 /*break*/, 4];
                    case 3:
                        this.cancelLoading();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.didEnterKeydown = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading()) {
                            return [2 /*return*/];
                        }
                        if (!this.canDone()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.didSelectDone()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.didSelectNext()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.startLoading = function () {
        this.loading++;
        this.updatePendingState();
    };
    WizardInteractor.prototype.cancelLoading = function () {
        this.loading--;
        this.updatePendingState();
    };
    WizardInteractor.prototype.startPending = function () {
        this.pending++;
        this.updatePendingState();
    };
    WizardInteractor.prototype.cancelPending = function () {
        this.pending--;
        this.updatePendingState();
    };
    WizardInteractor.prototype.didCatchError = function (err) {
        this.internalDidCatchError(err);
    };
    WizardInteractor.prototype.registerStepId = function (step) {
        this.stepRegistry[step.id] = step;
        if (step.unavailable) {
            this.stepsUnavailability[step.id] = true;
        }
    };
    WizardInteractor.prototype.updateStepAvailability = function (patchState) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Object.entries(patchState).forEach(function (_a) {
                            var stepId = _a[0], value = _a[1];
                            _this.stepsUnavailability[stepId] = !value;
                        });
                        return [4 /*yield*/, this.updateNavigation()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.updateStepDisableState = function (patchState) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Object.entries(patchState).forEach(function (_a) {
                            var stepId = _a[0], value = _a[1];
                            _this.stepsDisableState[stepId] = value;
                        });
                        return [4 /*yield*/, this.updateNavigation()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.switchStepById = function (id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var e_7;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.currentStepId === id) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 6]);
                        this.currentStepId = id;
                        this.startLoading();
                        return [4 /*yield*/, ((_a = this.router) === null || _a === void 0 ? void 0 : _a.switchStepById(id))];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.updateNavigation()];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        e_7 = _b.sent();
                        this.internalDidCatchError(e_7);
                        return [3 /*break*/, 6];
                    case 5:
                        this.cancelLoading();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.updateNavigation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var navigation, canSkip, hasPrev;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNavigation()];
                    case 1:
                        navigation = _a.sent();
                        return [4 /*yield*/, this.canSkip()];
                    case 2:
                        canSkip = _a.sent();
                        hasPrev = false;
                        try {
                            this.getNextOrPrevStepId(-1);
                            hasPrev = true;
                        }
                        catch (_b) { }
                        this.presenter.presentNavigation({
                            navigation: navigation,
                            actions: {
                                prev: hasPrev,
                                next: this.isNextAvailable(),
                                skip: canSkip,
                                done: this.canDone(),
                                cancel: this.canCancel()
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WizardInteractor.prototype.updatePendingState = function () {
        this.presenter.presentPending({ loading: this.isLoading(), pending: this.isPending() });
    };
    WizardInteractor.prototype.getNextOrPrevStepId = function (direction) {
        var stepIDs = this.getAvailableStepIDs();
        var nextIndex = this.getNextOrPrevStepIndex(direction);
        var nextId = stepIDs[nextIndex];
        if (!nextId) {
            throw new Error("WizardInteractor error: step is out of range");
        }
        return nextId;
    };
    WizardInteractor.prototype.canSkip = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // const step = await this.router.getActionableStep(this.currentStep);
                // return step.canSkip();
                // TODO: implement
                return [2 /*return*/, false];
            });
        });
    };
    WizardInteractor.prototype.canDone = function () {
        return this.isEnd() || this.isAllCompleted();
    };
    WizardInteractor.prototype.isEnd = function () {
        var stepIDs = this.getAvailableStepIDs();
        return stepIDs[stepIDs.length - 1] === this.currentStepId;
    };
    WizardInteractor.prototype.isNextAvailable = function () {
        if (this.isEnd()) {
            return false;
        }
        try {
            this.getNextOrPrevStepId(1);
            return true;
        }
        catch (_a) { }
        return false;
    };
    WizardInteractor.prototype.isAllCompleted = function () {
        var _this = this;
        var stepIDs = this.getNotDisabledAvailableStepIDs();
        return stepIDs.every(function (id) { return _this.completedIndex[id]; });
    };
    WizardInteractor.prototype.isLoading = function () {
        return this.loading > 0;
    };
    WizardInteractor.prototype.isPending = function () {
        return this.pending > 0;
    };
    WizardInteractor.prototype.getNavigation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stepsIDs, currentStepId, nextIndex;
            var _this = this;
            return __generator(this, function (_a) {
                stepsIDs = this.getAvailableStepIDs();
                currentStepId = this.currentStepId;
                nextIndex = this.getNextOrPrevStepIndex(1);
                return [2 /*return*/, stepsIDs.map(function (id, idx) {
                        var isNext = _this.config.isNextStepAvailable && nextIndex === idx;
                        var active = id === currentStepId;
                        var enable = idx === 0 ||
                            active ||
                            _this.completedIndex[id] ||
                            isNext ||
                            _this.completedIndex[stepsIDs[idx - 1]];
                        // TODO: skip by isCompleted or isSkipped?
                        return {
                            id: id,
                            disabled: _this.stepsDisableState[id] || !enable,
                            active: active
                        };
                    })];
            });
        });
    };
    WizardInteractor.prototype.completeCurrentStep = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var result, e_8;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, 3, 4]);
                        this.startLoading();
                        return [4 /*yield*/, ((_a = this.router) === null || _a === void 0 ? void 0 : _a.completeStepById(this.currentStepId))];
                    case 1:
                        result = (_b = (_c.sent())) !== null && _b !== void 0 ? _b : false;
                        this.completedIndex[this.currentStepId] = result;
                        return [2 /*return*/, result];
                    case 2:
                        e_8 = _c.sent();
                        this.internalDidCatchError(e_8);
                        return [3 /*break*/, 4];
                    case 3:
                        this.cancelLoading();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    WizardInteractor.prototype.internalDidCatchError = function (err) {
        if (typeof this.listener.didCatchError === 'function') {
            this.listener.didCatchError(err);
            return;
        }
        throw err;
    };
    WizardInteractor.prototype.getAvailableStepIDs = function () {
        var _this = this;
        return Object.values(this.stepRegistry)
            .sort(function (a, b) { return a.index - b.index; })
            .filter(function (step) { return !_this.stepsUnavailability[step.id]; })
            .map(function (value) { return value.id; });
    };
    WizardInteractor.prototype.getNotDisabledAvailableStepIDs = function () {
        var _this = this;
        return this.getAvailableStepIDs().filter(function (id) { return !_this.stepsDisableState[id]; });
    };
    WizardInteractor.prototype.getNextOrPrevStepIndex = function (direction) {
        var stepIDs = this.getAvailableStepIDs();
        var notDisabledStepsIDs = this.getNotDisabledAvailableStepIDs();
        var currentStepId = this.currentStepId;
        var nextIndex = notDisabledStepsIDs.indexOf(currentStepId) + direction;
        return stepIDs.indexOf(notDisabledStepsIDs[nextIndex]);
    };
    WizardInteractor.prototype.getStartStepId = function () {
        var ids = this.getAvailableStepIDs();
        var id = ids[0];
        if (!id) {
            throw new Error('WizardInteractor error: no steps registered');
        }
        return ids[0];
    };
    WizardInteractor.prototype.canCancel = function () {
        var _a, _b;
        var currentStepId = this.currentStepId;
        return (_b = (_a = this.stepRegistry[currentStepId]) === null || _a === void 0 ? void 0 : _a.canCancel) !== null && _b !== void 0 ? _b : true;
    };
    return WizardInteractor;
}(core_1.Interactor));
exports.WizardInteractor = WizardInteractor;
//# sourceMappingURL=WizardInteractor.js.map